
import React from 'react';
import { Button } from '@/components/ui/button';
import StatusFilters from './StatusFilters';
import ContentTypeFilters from './ContentTypeFilters';
import DateRangeFilters from './DateRangeFilters';
import NotesFilter from './NotesFilter';
import { VideoFilterOptions } from '@/hooks/useVideoEvents';

interface FilterFormProps {
  localFilters: VideoFilterOptions;
  handleStatusChange: (status: string, checked: boolean) => void;
  handleContentTypeChange: (type: string, checked: boolean) => void;
  handleNotesChange: (checked: boolean) => void;
  handleStartDateChange: (date: Date | undefined) => void;
  handleEndDateChange: (date: Date | undefined) => void;
  applyFilters: () => void;
  clearFilters: () => void;
  formatDate: (date: Date | undefined) => string;
}

const FilterForm: React.FC<FilterFormProps> = ({
  localFilters,
  handleStatusChange,
  handleContentTypeChange,
  handleNotesChange,
  handleStartDateChange,
  handleEndDateChange,
  applyFilters,
  clearFilters,
  formatDate,
}) => {
  return (
    <div className="space-y-4 font-sans">
      <StatusFilters 
        localFilters={localFilters} 
        handleStatusChange={handleStatusChange} 
      />

      <ContentTypeFilters 
        localFilters={localFilters} 
        handleContentTypeChange={handleContentTypeChange} 
      />

      <DateRangeFilters 
        localFilters={localFilters} 
        handleStartDateChange={handleStartDateChange} 
        handleEndDateChange={handleEndDateChange} 
        formatDate={formatDate} 
      />

      <NotesFilter 
        showNotes={localFilters.showNotes} 
        handleNotesChange={handleNotesChange} 
      />

      <div className="flex justify-between pt-2">
        <Button variant="outline" onClick={clearFilters} className="font-sans">
          Réinitialiser
        </Button>
        <Button onClick={applyFilters} className="social-profiles-button">
          Appliquer les filtres
        </Button>
      </div>
    </div>
  );
};

export default FilterForm;
